import React, { useEffect, useRef, useState } from "react";
import PubSub from "pubsub-js";
import styled, { keyframes } from "styled-components";

const ballAnimation = keyframes`
  0% { transform: translate(-50%, -25px); }
  // 40% { transform: translate(-50%, 0px); }
  // 50% { transform: translate(-50%, 1px); }
  // 75% { transform: translate(-50%, 13px); }
  100% { transform: translate(-50%, 25px); }
`;

const Wrapper = styled.div`
  overflow: hidden;
  max-height: var(--headerHeight);
  &.item-added .ball,
  &:hover .ball {
    opacity: 1;
    animation: ${ballAnimation} 1s ease infinite;
  }
`;

const Ball = styled.div`
  position: absolute;
  // left: 50%;
  right: 0;
  top: 50%;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: #d9654d;
  opacity: 0;
  transform: translate(-50%, -50%);
  // animation: ${ballAnimation} 1s ease infinite;
`;

const Cart = () => {
  const [count, setCount] = useState(0);
  const cartRef = useRef();
  // useEffect(() => {
  //   console.log("count", count);
  // }, [count]);

  useEffect(() => {
    const { Snipcart } = window;
    if (!Snipcart) return;

    const tokenEsc = PubSub.subscribe("ESC", _onClose);

    document.addEventListener("snipcart.ready", function () {
      // Snipcart.setLang("fr");
      // Snipcart.api.session.setLanguage("fr");
    });

    Snipcart.events.on("snipcart.initialization.error", () => {
      // console.log("Failed to initialize Snipcart");
    });

    Snipcart.events.on("item.added", cartItem => {
      // console.log("item.added", Snipcart.store.getState().cart.items.count);
      PubSub.publish("ITEM.ADDED");
      setCount(Snipcart.store.getState().cart.items.count);
      if (cartRef) {
        cartRef.current.classList.add("item-added");
        setTimeout(() => {
          cartRef.current.classList.remove("item-added");
        }, 2000);
      }
    });
    Snipcart.events.on("item.removed", cartItem => {
      // console.log("item.removed", Snipcart.store.getState().cart.items.count);
      setCount(Snipcart.store.getState().cart.items.count);
    });

    return () => {
      PubSub.unsubscribe(tokenEsc);
    };
  }, []);

  const _onClose = () => {
    // const { Snipcart } = window;
    // if (!Snipcart) return;

    // Snipcart.api.theme.cart.close();
    document.querySelector(".snipcart-modal__close").click();
  };

  return (
    <Wrapper className='cart flex items-center' ref={cartRef}>
      {count > 0 && <span className='snipcart-items-count'>{count}</span>}
      {/* <span className='snipcart-items-count'>3</span> */}
      <button
        className='snipcart-checkout z-10 relative flex-- items-center block'
        aria-label='open cart'
        title='open cart'>
        {/* <span>PANIER</span> */}

        {/* <span className='snipcart-items-count'>3</span> */}
        <svg
          className='pen'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M1 1L4.49 14.94M1 1H15.22H1ZM13.91 6.25L10.44 1.02L13.91 6.25ZM2.33 6.38L5.89 1.01L2.33 6.38ZM3.39 10.53L9.7 1.01L3.39 10.53ZM12.89 10.32L6.73 1.02L12.89 10.32ZM4.45 14.92L13.68 1.01L4.45 14.92ZM14.31 4.63L8.08 14.93L14.31 4.63ZM11.73 14.93L2.51 1.01L11.73 14.93ZM1.95 4.79L8.08 14.94L1.95 4.79ZM15.22 1L11.73 14.94L15.22 1Z'
            stroke='black'
            strokeWidth='0.732'
            strokeMiterlimit='10'
          />
        </svg>
      </button>
      <Ball className='ball'></Ball>
      {/* <span class="snipcart-total-price"></span> */}
    </Wrapper>
  );
};

export default Cart;
